import React from "react";
import { Outlet } from "react-router-dom";

import Navigation from "../../../../components/navigations/client/detail/navigation";
import useParentLoaderData from "../../../../hooks/useParentLoaderData";

export default () => {
  const { _case } = useParentLoaderData(2);
  return (
    <Navigation activeTab="case" _case={_case}>
      <div className="overflow-y-auto rounded-b-[15px] bg-white">
        <Outlet />
      </div>
    </Navigation>
  );
};
